module.exports = __webpack_public_path__ + "static/media/lupaBlack.4e8fa515.svg";